import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import {
  IconArrowRight,
  IconMedicalChatbot,
  IconPharmacy,
  IconPhone,
} from '@redteclab/icons'

import { Button } from 'base-ui'

import {
  DirectContactCallSchedulingDialog,
  DirectContactPharmaTelephoneDialog,
} from '../../direct-contact'
import { useOpenableControls } from '../../generic-hooks'
import { useGlobalConfigContext } from '../../global-config'
import { TENANT } from '../../tenant'

import { ContactPageFormLabel } from './ContactPageDirectContactLabels/ContactPageFormLabel'

export const ContactPageDirectContactPharmaLabelsSection: FC<{
  onSuccess: () => void
}> = ({ onSuccess }) => {
  const modalControlsCallSchedulingDialog = useOpenableControls()
  const modalControlsPharmaTelephoneDialog = useOpenableControls()
  const config = useGlobalConfigContext()
  const { tenant } = config

  const intl = useIntl()

  if (tenant !== TENANT.COM) {
    return null
  }

  const DATA_LAUNCH_CHAT_SYMPTOMBERATUNG = 'dp_campaign_explanation'

  const pharmaConsult = intl.formatMessage({
    id: 'contactForm.select.item.consultation',
  })

  return (
    <>
      <div className="flex flex-1 flex-col items-start justify-between">
        <h2 className="mb-4 whitespace-normal text-l font-medium">
          <FormattedMessage id="contact.helpAndAdviceSection.expert.title" />
        </h2>
        <div className="flex w-full flex-col justify-start gap-6 rounded-2xl border border-dark-primary-min p-6">
          <Button
            data-launch-chat={JSON.stringify({
              intent: DATA_LAUNCH_CHAT_SYMPTOMBERATUNG,
              theme: 'default',
            })}
            endIcon={<IconArrowRight className="fill-dark-brand" />}
            id="contact.call.chatbot.label.v2"
            size="large"
            startIcon={<IconMedicalChatbot className="fill-dark-brand" />}
            variant="text"
          >
            <span className="grow whitespace-normal text-start">
              <FormattedMessage id="contact.helpAndAdviceSection.pharmaChatbotTextCta.label" />
            </span>
          </Button>
          <Button
            endIcon={<IconArrowRight className="fill-dark-brand" />}
            onClick={() => {
              modalControlsPharmaTelephoneDialog.handleOpen()
            }}
            size="large"
            startIcon={<IconPharmacy className="fill-dark-brand" />}
            variant="text"
          >
            <span className="grow whitespace-normal text-start">
              <FormattedMessage id="contact.helpAndAdviceSection.pharmaCustomerSupport.label" />
            </span>
          </Button>
          <Button
            endIcon={<IconArrowRight className="fill-dark-brand" />}
            id="contact.call.scheduling.label.v2"
            onClick={() => {
              modalControlsCallSchedulingDialog.handleOpen()
            }}
            size="large"
            startIcon={<IconPhone className="fill-dark-brand" />}
            variant="text"
          >
            <span className="grow whitespace-normal text-start">
              <FormattedMessage id="contact.callSchedulingModal.title" />
            </span>
          </Button>

          <ContactPageFormLabel
            formSubject={pharmaConsult}
            onSuccess={onSuccess}
          />
        </div>
      </div>
      <DirectContactCallSchedulingDialog
        modalControls={modalControlsCallSchedulingDialog}
      />

      <DirectContactPharmaTelephoneDialog
        modalControls={modalControlsPharmaTelephoneDialog}
        onCustomerSupportUnavailableFormSubmittedWithSuccess={onSuccess}
      />
    </>
  )
}
